module.exports = __webpack_public_path__ + "static/media/kop_surat.24d5eb33.png";